import { LicenseOption } from "Types";

/**
 * @param licenses list of licenses
 * @param allLicenseOptions list of all license options
 * @param inputValue input value
 * @returns license options filtered by the input value (by license and by identifier)
 */
export const filterLicenses = (
  licenses: string[],
  allLicenseOptions: LicenseOption[],
  inputValue: string,
): string[] => {
  const inputValueLowerCase = inputValue.toLowerCase();

  return licenses.filter((license) => {
    if (license.toLowerCase().includes(inputValueLowerCase)) return true;

    const licenseIdentifier =
      allLicenseOptions
        .find((item) => item.license === license)
        ?.identifier.toLowerCase() ?? "";

    return licenseIdentifier.includes(inputValueLowerCase);
  });
};
